var React = require('react');

function TrashForCart (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_material-delete","data-name":"Icon material-delete","d":"M8.643,22.786a2.292,2.292,0,0,0,2.286,2.286h9.143a2.292,2.292,0,0,0,2.286-2.286V9.071H8.643ZM23.5,5.643h-4L18.357,4.5H12.643L11.5,5.643h-4V7.929h16Z","transform":"translate(-7.5 -4.5)","fill":"#e1e1e1"}));
}

TrashForCart.defaultProps = {"width":"16","height":"20.571","viewBox":"0 0 16 20.571"};

module.exports = TrashForCart;

TrashForCart.default = TrashForCart;
